import AbstractProvidedClass from "./AbstractProvidedClass";

export default class AbstractSettings extends AbstractProvidedClass {
    showGridCheckbox;
    showLabelCheckbox;
    unitSelector;

    init({ showImage = true, showGrid = true, showLabels = true } = {}) {
        this.showGrid = showGrid;
        this.showLabels = showLabels;
        this.showImage = showImage;
        this.units = 'metric';
    }

    get showGrid() {
        return this.showGridCheckbox.checked() == 1;
    }

    set showGrid(showGrid) {
        this.showGridCheckbox.checked(showGrid ? 1 : 0);
        if (this.snapToGridCheckbox) {
            this.snapToGrid = showGrid;
            this.snapToGridCheckbox.elt.firstChild.firstChild.disabled = !showGrid;
        }
    }

    get showLabels() {
        return this.showLabelCheckbox.checked() == 1;
    }

    set showLabels(showLabels) {
        this.showLabelCheckbox.checked(showLabels ? 1 : 0);
    }

    get showImage() {
        return this.showImageCheckbox.checked() == 1;
    }

    set showImage(showImage) {
        this.showImageCheckbox.checked(showImage ? 1 : 0);
        this.imageMenu?.showImageCheckbox.checked(showImage ? 1 : 0);
    }

    get units() {
        return this.unitSelector.value();
    }

    set units(units) {
        this.unitSelector.value(units);
    }

    get metric() {
        return this.unitSelector.value() == 'metric';
    }

    get imperial() {
        return this.unitSelector.value() == 'imperial';
    }

    store() {
        // Store is only implemented for the edit view
    }
}
